export class ForgotPasswordModel {
    Email: string = "";
}


// WEBPACK FOOTER //
// ./app/objects/users/forgotPasswordModel.ts